import { createFileRoute, redirect } from '@tanstack/react-router';

import { ResetPasswordPage } from '@/pages/auth/reset-password';

interface ResetPasswordSearch {
  token?: string;
}
export const Route = createFileRoute('/(auth)/reset-password')({
  beforeLoad: ({ context }) => {
    if (context.auth.isAuthenticated && context.auth.user?.is_email_verified) {
      throw redirect({ to: '/courses' });
    }
  },
  validateSearch: (search: Record<string, string>): ResetPasswordSearch => ({
    token: search.token ?? '',
  }),
  component: ResetPasswordPage,
});
